import "core-js/modules/es6.string.small";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalSlogan from '~/components/molecules/Editorial/Global/GlobalSlogan.vue';

const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'LandingHeaderWithImage',
  components: {
    GlobalRichText,
    GlobalSlogan
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

      return {
        background_image: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.background_image) != null ? _ref10.url : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
        slogan: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.slogan_text : _ref9 : _ref9) || '',
        sloganColor: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.slogan_text_color : _ref8 : _ref8) || '',
        sloganIconColor: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.slogan_icon_color : _ref7 : _ref7) || '',
        richText: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.rich_text : _ref6 : _ref6) || [],
        image: {
          alt: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.image) != null ? (_ref5 = _ref5.alt) != null ? (_ref5 = _ref5[0]) != null ? _ref5.text : _ref5 : _ref5 : _ref5 : _ref5 : _ref5) || '',
          small: formatPrismicImage((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.image) != null ? (_ref4 = _ref4.small) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? (_ref3 = _ref3.image) != null ? (_ref3 = _ref3.medium) != null ? _ref3.url : _ref3 : _ref3 : _ref3 : _ref3) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? (_ref2 = _ref2.image) != null ? (_ref2 = _ref2.large) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.image) != null ? (_ref = _ref.xlarge) != null ? _ref.url : _ref : _ref : _ref : _ref) || EMPTY_PIXEL
        }
      };
    }

  }
};